import PropTypes from 'prop-types';

import { AlertBox } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { HowToBookSection } from './HowToBookSection';

import './HowToBook.scss';
import CheckPolicyIcon from './icons/CheckPolicyIcon';
import RentalConditionsGuaranteeIcon from './icons/RentalConditionsGuaranteeIcon';

const HowToBook = ({ hasVetting = false }) => {
  const ITEMS = [
    {
      id: 1,
      renderContent: () => {
        return (
          <ul>
            <li>{trans('listing.how-to-book.step-1.point-1')}</li>
            <li>{trans('listing.how-to-book.step-1.point-2')}</li>
            <li>{trans('listing.how-to-book.step-1.point-3')}</li>
          </ul>
        );
      }
    },
    {
      id: 2,
      renderContent: () => {
        return (
          <ul>
            <li>{trans('listing.how-to-book.step-2.point-1')}</li>
            <li>{trans('listing.how-to-book.step-2.point-2')}</li>
          </ul>
        );
      }
    },
    {
      id: 3,
      renderContent: () => {
        return (
          <ul>
            <li>{trans('listing.how-to-book.step-3.point-1')}</li>
            <li>{trans('listing.how-to-book.step-3.point-2')}</li>
            <li>{trans('listing.how-to-book.step-3.point-3')}</li>
            <li>
              <span
                dangerouslySetInnerHTML={{
                  __html: trans('listing.how-to-book.step-3.point-4')
                }}
              />
              <ul>
                <li>
                  {trans('listing.how-to-book.step-3.point-4.subpoint-1')}
                </li>
                <li>
                  {trans('listing.how-to-book.step-3.point-4.subpoint-2')}
                </li>{' '}
                <li>
                  {trans('listing.how-to-book.step-3.point-4.subpoint-3')}
                </li>
              </ul>
            </li>
          </ul>
        );
      }
    },
    {
      id: 4,
      renderContent: () => {
        return (
          <ul>
            <li>{trans('listing.how-to-book.step-4.point-1')}</li>
            <li>{trans('listing.how-to-book.step-4.point-2')}</li>
          </ul>
        );
      }
    }
  ];

  return (
    <div className="how-to-book-redesign">
      <div className="how-to-book-redesign__wrapper">
        {ITEMS.map(({ id, icon, renderContent, isCollapsed }) => (
          <HowToBookSection
            key={id}
            stepNumber={id}
            Icon={icon}
            isCollapsed={isCollapsed}
            title={`listing.how-to-book.step-${id}.title`}
            renderContent={renderContent}
          />
        ))}
      </div>
      <AlertBox
        className="how-to-book-redesign__alert-box"
        titleClassName="how-to-book-redesign__alert-box__title"
        iconClassName="how-to-book-redesign__alert-box__icon"
        icon={<CheckPolicyIcon />}
        iconPosition="top"
        title={trans('listing.how-to-book.24h-check.policy.title')}
        message={
          <div className="how-to-book-redesign__alert-box__message">
            {trans('listing.how-to-book.24h-check.policy.message')}
          </div>
        }
        roundedCorners
        theme="white"
      />
      {hasVetting && (
        <AlertBox
          className="how-to-book-redesign__alert-box"
          titleClassName="how-to-book-redesign__alert-box__title"
          iconClassName="how-to-book-redesign__alert-box__icon"
          icon={<RentalConditionsGuaranteeIcon />}
          iconPosition="top"
          title={trans('listing.how-to-book.early-checkout.title')}
          message={
            <div className="how-to-book-redesign__alert-box__message">
              {trans('listing.how-to-book.early-checkout.message')}
            </div>
          }
          roundedCorners
          theme="white"
        />
      )}
    </div>
  );
};

HowToBook.propTypes = {
  hasVetting: PropTypes.bool
};

export default HowToBook;
